import { TableModels } from '../../../../models/table.models';

export function projectPaginatedResult<TApiModel, TModel>(
  apiModel: TableModels.PaginatedResult<TApiModel>,
  projector: (apiModel: TApiModel) => TModel,
): TableModels.PaginatedResult<TModel> {
  return {
    resultCount: apiModel.resultCount,
    result: apiModel.result.map(projector),
  };
}
